import { render, staticRenderFns } from "./tit-wrap-small.vue?vue&type=template&id=8a117862&scoped=true"
import script from "./tit-wrap-small.vue?vue&type=script&lang=js"
export * from "./tit-wrap-small.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a117862",
  null
  
)

export default component.exports